import React, { useState } from "react";
import "./AppWrapper.css";
import Sidebar from "./Sidebar/Sidebar";
import PolarisNav from "./Sidebar/PolarisNav";
import PolarisTopBar from "./Sidebar/PolarisTopBar";
import RouterLink from "./Sidebar/RouterLink";
import PrivateRoute from "./PrivateRoute";
import { AppProvider, Frame } from "@shopify/polaris";
import esTranslations from "@shopify/polaris/locales/es.json";
import { UserAuth } from "../context/AuthContext";

const LOGO = {
  topBarSource: "/images/logo_dark_bg_256.webp",
  width: 56,
  url: "/dashboard",
  accessibilityLabel: "GoMove",
};

function AppWrapper({ children, protectedContent = true }) {
  const { navLayout } = UserAuth();
  const [mobileNav, setMobileNav] = useState(false);

  // Per-user choice (users.menu_preferences._layout); classic unless opted in.
  if (navLayout === "polaris") {
    return (
      <PrivateRoute protectedRoute={protectedContent}>
        <AppProvider i18n={esTranslations} linkComponent={RouterLink}>
          <Frame
            logo={LOGO}
            topBar={<PolarisTopBar onNavigationToggle={() => setMobileNav((o) => !o)} />}
            navigation={<PolarisNav />}
            showMobileNavigation={mobileNav}
            onNavigationDismiss={() => setMobileNav(false)}
          >
            {children}
          </Frame>
        </AppProvider>
      </PrivateRoute>
    );
  }

  return (
    <PrivateRoute protectedRoute={protectedContent}>
      <Sidebar />
      <div className="main_app_wrapper_content">
        <AppProvider className="main_app_provider" i18n={esTranslations}>
          <Frame>
            {children}
          </Frame>
        </AppProvider>
      </div>
    </PrivateRoute>
  );
}

export default AppWrapper;
